// types
import { AppErrorKind } from 'types/errors'
// constants
import { CHART_ERROR_MESSAGES, ChartErrorCode } from 'constants/chartErrors'

// Overrides for codes the backend sends with the code itself as the message.
// Every other coded error is shown with the backend's own message (see getUserMessage).
export const ERROR_MESSAGES_BY_CODE: Record<string, string> = {
  DUPLICATED_USERNAME: 'A user with this username already exists.',
  DUPLICATED_LINKING: 'This plan item is already linked.',
  PLAN_ITEM_CHILDREN_PERSIST: 'Please remove subitems first.',
  // Mutation errors of the charts; their query errors are shown on the tile (getChartErrorMessage)
  [ChartErrorCode.ConfigInvalid]: CHART_ERROR_MESSAGES[ChartErrorCode.ConfigInvalid],
  [ChartErrorCode.FilterUsedByCharts]: CHART_ERROR_MESSAGES[ChartErrorCode.FilterUsedByCharts]
}

export const ERROR_MESSAGES_BY_KIND: Record<AppErrorKind, string> = {
  [AppErrorKind.NETWORK]: 'No connection to the server. Please check your network and try again.',
  [AppErrorKind.AUTH]: 'Your session has expired. Please sign in again.',
  [AppErrorKind.FORBIDDEN]: 'You do not have permission to perform this action.',
  [AppErrorKind.VALIDATION]: 'Please check the entered data and try again.',
  [AppErrorKind.SERVER]: 'Server error. Please try again later.',
  [AppErrorKind.UNKNOWN]: 'Something went wrong. Please try again.'
}
